module.exports = __webpack_public_path__ + "static/media/xlsxFileExtension.c32a61cb.svg";